const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

const permissionsService = {
  // Get all permissions (for index page)
  getPermissions: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/permissions`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching permissions:", error);

      // Mock data fallback - exact Laravel structure
      return {
        success: true,
        source: "mock",
        data: {
          permissions: [
            { id: 2452, display_name: "Manage blocks", name: "blocks.manage", category_id: null },
            { id: 2453, display_name: "Index Clients", name: "clients.index", category_id: 5 },
            { id: 2454, display_name: "Create Client", name: "clients.create", category_id: 5 },
            { id: 2455, display_name: "Edit Client", name: "clients.edit", category_id: 5 },
            { id: 2456, display_name: "Delete Client", name: "clients.delete", category_id: 5 },
            { id: 2457, display_name: "Show Client", name: "clients.show", category_id: 5 },
            { id: 2458, display_name: "Show All Clients", name: "clients.show.all", category_id: 5 },
            { id: 2459, display_name: "Send Mass Email To Clients", name: "clients.email", category_id: 5 },
            { id: 2460, display_name: "Client Dashboard", name: "clients.dashboard", category_id: 5 },
            { id: 2461, display_name: "Client's Tickets", name: "clients.tickets", category_id: 5 },
            { id: 2462, display_name: "Index Contractors", name: "contractors.index", category_id: 7 },
            { id: 2463, display_name: "Create Contractor", name: "contractors.create", category_id: 7 },
            { id: 2464, display_name: "Edit Contractor", name: "contractors.edit", category_id: 7 },
            { id: 2465, display_name: "Delete Contractor", name: "contractors.delete", category_id: 7 },
            { id: 2466, display_name: "Show Contractor", name: "contractors.show", category_id: 7 },
            { id: 2467, display_name: "Contractor Dashboard", name: "contractors.dashboard", category_id: 7 },
            { id: 2468, display_name: "Contractor Contact Calendar", name: "contractors.contacts.calendar", category_id: 7 },
            { id: 2469, display_name: "Index Guardians", name: "guardians.index", category_id: 2 },
            { id: 2470, display_name: "Create Guardian", name: "guardians.create", category_id: 2 },
            { id: 2471, display_name: "Edit Guardian", name: "guardians.edit", category_id: 2 },
            { id: 2472, display_name: "Delete Guardian", name: "guardians.destroy", category_id: 2 },
            { id: 2473, display_name: "Show Guardian", name: "guardians.show", category_id: 2 },
            { id: 2474, display_name: "Assign Guardian", name: "guardians.assign", category_id: 2 },
            { id: 2475, display_name: "Change status of guardian", name: "guardians.status.change", category_id: 2 },
            { id: 2476, display_name: "Disapprove guardian", name: "guardians.disapprove", category_id: 2 },
            { id: 2477, display_name: "Guardian's Payments", name: "guardians.payments", category_id: 2 },
            { id: 2478, display_name: "Guardian Officer", name: "guardian.officer", category_id: 2 },
            { id: 2479, display_name: "Send payment reminder to guardian", name: "guardians.send-payment-reminder", category_id: 2 },
            { id: 2480, display_name: "Send license to sign reminder", name: "guardians.send-license-to-sign-reminder", category_id: 2 },
            { id: 2481, display_name: "Send empty property tip", name: "guardians.empty-property-tip.create", category_id: 2 },
            { id: 2482, display_name: "Recommend a friend", name: "recommend-a-friend.send", category_id: 2 },
            { id: 2483, display_name: "Move Guardian", name: "guardians.move", category_id: 2 },
            { id: 2484, display_name: "Email guardians of status", name: "guardians.emails.status", category_id: 2 },
            { id: 2485, display_name: "Restore Declined Guardian", name: "guardians.canRestoreDeclined", category_id: 2 },
            { id: 2486, display_name: "Manage inspections", name: "inspections.manage", category_id: 4 },
            { id: 2487, display_name: "Show inspections", name: "inspections.show", category_id: 4 },
            { id: 2488, display_name: "Manage inspection types", name: "inspection_types.manage", category_id: 4 },
            { id: 2489, display_name: "Manage Properties", name: "properties.manage", category_id: 4 },
            { id: 2490, display_name: "View Properties", name: "properties.view", category_id: 4 },
            { id: 2491, display_name: "Manage Finance", name: "finance.manage", category_id: 3 },
            { id: 2492, display_name: "Manage Profit and Loss", name: "finances.profit_and_loss.manage", category_id: 3 },
            { id: 2493, display_name: "Manage Bank Accounts", name: "finances.bank_accounts.manage", category_id: 3 },
            { id: 2494, display_name: "Payments List", name: "payments.list", category_id: 3 },
            { id: 2495, display_name: "Payments Manage", name: "payments.manage", category_id: 3 },
            { id: 2496, display_name: "Payments Report", name: "payments.report", category_id: 3 },
            { id: 2497, display_name: "Manage Marketing Stuff", name: "marketing.manage", category_id: 8 },
            { id: 2498, display_name: "Menu", name: "menu", category_id: 10 },
            { id: 2499, display_name: "Menu Dropdown", name: "menu.dropdown", category_id: 10 },
            { id: 2500, display_name: "See guardian rent prices", name: "see_rent_prices", category_id: 2 }
          ],
          permissionCategories: [
            { id: 1, name: "Users", permissions_count: 0 },
            { id: 2, name: "Guardians", permissions_count: 15 },
            { id: 3, name: "Finance", permissions_count: 6 },
            { id: 4, name: "Properties", permissions_count: 4 },
            { id: 5, name: "Clients", permissions_count: 10 },
            { id: 6, name: "Tickets", permissions_count: 0 },
            { id: 7, name: "Contractors", permissions_count: 7 },
            { id: 8, name: "Marketing", permissions_count: 1 },
            { id: 9, name: "Quality", permissions_count: 0 },
            { id: 10, name: "Menu", permissions_count: 2 }
          ],
        },
        message: "Permissions retrieved (mock)",
      };
    }
  },

  // Get permission edit data
  getPermissionEdit: async (id) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/permissions/${id}/edit`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("❌ Error fetching permission edit data:", error);
      
      // Mock data fallback
      const mockPermission = {
        id: parseInt(id),
        name: "clients.index",
        display_name: "Index Clients",
        description: "Let index clients",
        route: "clients"
      };

      const mockRoles = [
        { id: 1, name: "System Administrator" },
        { id: 2, name: "Senior Management" }
      ];

      const mockUsers = [
        { id: 1, fullName: "John Smith" },
        { id: 2, fullName: "Jane Doe" }
      ];

      const mockDepartments = [
        { id: 1, name: "IT Department", color: "#007bff" },
        { id: 2, name: "HR Department", color: "#28a745" }
      ];

      return {
        success: true,
        source: "mock",
        data: {
          permission: mockPermission,
          roles: mockRoles,
          directlyAddedUsers: mockUsers,
          departments: mockDepartments
        }
      };
    }
  },

  // Update permission
  updatePermission: async (id, formData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/permissions/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("❌ Error updating permission:", error);
      
      // Mock response
      return {
        success: true,
        source: "mock",
        message: "Permission updated successfully (mock mode)"
      };
    }
  },

  // Get permission category users
  getCategoryUsers: async (categoryId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/permissions/category/${categoryId}/users`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching category users:", error);

      // Mock data fallback
      const mockCategories = {
        1: { id: 1, name: "Users" },
        2: { id: 2, name: "Guardians" },
        3: { id: 3, name: "Finance" },
        4: { id: 4, name: "Properties" },
        5: { id: 5, name: "Clients" },
        6: { id: 6, name: "Tickets" },
        7: { id: 7, name: "Contractors" },
        8: { id: 8, name: "Marketing" },
        9: { id: 9, name: "Quality" },
        10: { id: 10, name: "Menu" }
      };

      const mockUsers = [
        { id: 1, name: "John Smith", email: "john.smith@example.com", role: "System Administrator" },
        { id: 2, name: "Jane Doe", email: "jane.doe@example.com", role: "Senior Management" },
        { id: 3, name: "Bob Johnson", email: "bob.johnson@example.com", role: "Client" },
        { id: 4, name: "Alice Brown", email: "alice.brown@example.com", role: "Guardian" },
        { id: 5, name: "Charlie Wilson", email: "charlie.wilson@example.com", role: "Contractor" }
      ];

      return {
        success: true,
        source: "mock",
        data: {
          category: mockCategories[categoryId] || { id: parseInt(categoryId), name: "Unknown Category" },
          users: mockUsers
        }
      };
    }
  },

  // Update permission category
  updateCategory: async (categoryId, formData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/permissions/category/${categoryId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error updating category:", error);
      
      // Mock response
      return {
        success: true,
        source: "mock",
        message: "Category updated successfully (mock mode)"
      };
    }
  },

  // Add user to permission
  addUserToPermission: async (permissionId, userId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/permissions/user/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          permission_id: permissionId,
          user_id: userId
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error adding user to permission:", error);
      
      // Mock response
      return {
        success: true,
        source: "mock",
        message: "User added to permission successfully (mock mode)"
      };
    }
  },

  // Remove user from permission
  removeUserFromPermission: async (permissionId, userId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/permissions/user/remove`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          permission_id: permissionId,
          user_id: userId
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error removing user from permission:", error);
      
      // Mock response
      return {
        success: true,
        source: "mock",
        message: "User removed from permission successfully (mock mode)"
      };
    }
  }
};

export default permissionsService;
